import vPortal from "../../setup/js/_vportal";

$(document).on("pubgm_mainsite_main_sub_event_details rendered", {}, function(event, uniqueId){
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    // $(".news").each(function () {
    //     var postsTag = "#" + $(this).attr("id");
    //
    //     $().vPortal({
    //         container: postsTag,
    //         el: {
    //             tabContainer: '.news_tab > ul',
    //             resultContainer: '.news_list',
    //         },
    //         paginationOptions: {
    //         }
    //     });
    //
    // });
});